import { renderSlot, type ButtonHTMLAttributes } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import Icon, { type IconDefinition } from "../Icon"
import type { Props as BootstrapButtonProps } from "./BootstrapButton"
import BootstrapButton from "./BootstrapButton"

interface Props extends BootstrapButtonProps {
	icon: IconDefinition
}

const IconButton: ReactiveComponent<Props, ButtonHTMLAttributes> = (props, { slots, attrs }) => {
	return () => (
		<BootstrapButton {...props} {...attrs}>
			<Icon style={{ width: "1em" }} icon={props.icon} />
			{renderSlot(slots, "default")}
		</BootstrapButton>
	)
}

export default defineComponent(IconButton, inferProps<Props>())
